import { GridOptions, RowStyle, ValueFormatterParams } from '@ag-grid-community/core';

import { AgRawTooltip } from '@shared/components/ag-raw-tooltip/ag-raw-tooltip';
import { ZERO_HYPHEN } from '@shared/constants/format';
import { TableConstants } from '@shared/constants/table.constants';
import { AuxExcelFormats } from '@shared/utils';
import { AuxExcelStyleKeys } from '@shared/utils/aux-excel-styles/aux-excel-style-keys';
import { AuxExcelStyles, GetExcelStyle } from '@shared/utils/aux-excel-styles/aux-excel-styles';
import { Utils } from '@shared/utils/utils';

import { QCGridData } from '../../../../period-close.model';

export const DEFAULT_MONTH_CLOSE_GRID_CONFIG: GridOptions<QCGridData> = {
  defaultColDef: {
    ...TableConstants.DEFAULT_GRID_OPTIONS.DEFAULT_COL_DEF,
    filter: true,
    menuTabs: ['filterMenuTab'],
    minWidth: 70,
    resizable: true,
    sortable: false,
    suppressMenu: false,
    tooltipComponent: AgRawTooltip,
    tooltipValueGetter: (params) => params.valueFormatted || '',
    valueFormatter: (params: ValueFormatterParams) => params.value || ZERO_HYPHEN,
  },
  excelStyles: [
    ...Utils.generateExcelCurrencyStyles(Utils.CURRENCY_OPTIONS),
    ...AuxExcelStyles,
    {
      ...GetExcelStyle(AuxExcelStyleKeys.FIRST_ROW),
      borders: {
        borderBottom: {
          color: 'black',
          lineStyle: 'Continuous',
          weight: 1,
        },
      },
      id: 'trial_name',
    },
    {
      alignment: { horizontal: 'Right' },
      id: 'budget-percent',
      numberFormat: { format: AuxExcelFormats.PercentWithout100Mult },
    },
    {
      alignment: {
        wrapText: true,
      },
      id: 'wrapText',
    },
  ],
  getRowHeight: (params) => {
    if (params.node.isRowPinned()) {
      return 48;
    }

    return 40;
  },
  getRowStyle: (params) => {
    if (params.node.isRowPinned()) {
      return <RowStyle>{ '--ag-row-height': '48px' };
    }

    return {};
  },
  headerHeight: 48,
  rowHeight: 40,
  suppressAggFuncInHeader: true,
  suppressCellFocus: true,
  suppressMenuHide: true,
  suppressRowClickSelection: true,
  suppressRowTransform: true,
  tooltipShowDelay: 500,
};
